var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseCommonPage',[_c(_vm.component,_vm._b({tag:"div"},'div',{ designId: _vm.designId },false))],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }